// extracted by mini-css-extract-plugin
export default {"formTitle":"EmailVerifiedForm_formTitle__Jsr3q","formText":"EmailVerifiedForm_formText__waMJ3"};